import React from 'react';
import { useSelector } from 'react-redux';
import WelcomeMenus from '../../WelcomeMenus';
import UploadTestimonialForm from './UploadTestimonialForm';

const AddNewTestimonial = () => {
  const { user } = useSelector((s) => s.auth);
  const userId = user?.role_id;

  return (
    <div>
      {userId === 1 ? <UploadTestimonialForm /> : (
        <>
          <h2>Admin only can add testimonials</h2>
          <WelcomeMenus />
        </>
      )}
    </div>
  );
};

export default AddNewTestimonial;
